import React from 'react';

// ** MUI Imports
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

// ** Components
import UserDropdown from './UserDropdown';
import FaIconUvilo from '@erikdakoda/ui/components/FaIconUvilo';
import Link from 'next/link';

// ** Hooks
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@erikdakoda/ui/hooks/useCurrentUser';

// ** Settings
import type { Settings } from '@erikdakoda/site-template-ui/context/settingsContext';

interface AppBarContentProps {
  settings: Settings;
  saveSettings: (values: Settings) => void;
}

const AppBarContent = (props: AppBarContentProps) => {
  const { settings, saveSettings } = props;
  const { isAuthenticated } = useCurrentUser();
  const { t } = useTranslation('uvilo-ai');

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {isAuthenticated ? (
        <UserDropdown settings={settings} saveSettings={saveSettings} />
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <Button
            component={Link}
            href="/signup"
            variant="contained"
            color="primary"
            size="small"
            sx={{ whiteSpace: 'nowrap' }}
          >
            {t('applyNow')}
          </Button>
          <Button
            component={Link}
            href="/login"
            variant="outlined"
            color="primary"
            size="small"
            sx={{ whiteSpace: 'nowrap', color: 'primary.dark', borderColor: 'primary.dark' }}
          >
            {t('logIn')}
          </Button>
          <IconButton size="small" edge="end" sx={{ display: { xs: 'inline-flex', md: 'none' } }}>
            <FaIconUvilo icon="bars" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default AppBarContent;
